import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const CollapsePanel = ({ id, title, icon: Icon, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`collapse-panel ${open ? "open" : ""}`} data-testid={`collapse-${id}`}>
      <button type="button" className="collapse-head" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid={`collapse-${id}-toggle`}>
        <span className="collapse-title">{Icon && <Icon size={16} style={{ color: "var(--joy-yellow)" }} />}{title}</span>
        <ChevronDown size={18} className="collapse-chev" />
      </button>
      {open && <div className="collapse-body" data-testid={`collapse-${id}-body`}>{children}</div>}
    </div>
  );
};
